(function () {
  'use strict';

  function updateMobileCartCount() {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to fetch cart.');
        }

        return response.json();
      })
      .then(function (cart) {
        var cartIcons = document.querySelectorAll('.mobile-cart-icon');

        cartIcons.forEach(function (cartIcon) {
          var existingBadge = cartIcon.querySelector('.mobile-cart-count');

          if (cart.item_count > 0) {

            if (!existingBadge) {
              existingBadge = document.createElement('span');
              existingBadge.className = 'mobile-cart-count';
              cartIcon.appendChild(existingBadge);
            }

            existingBadge.textContent = cart.item_count;

          } else {

            if (existingBadge) {
              existingBadge.remove();
            }

          }
        });
      })
      .catch(function (error) {
        console.warn('Mobile cart count:', error);
      });
  }


  /*
   * Update shortly after a product form is submitted.
   * This works with standard Shopify product forms.
   */
  document.addEventListener('submit', function (event) {

    var form = event.target;

    if (!form || form.tagName !== 'FORM') {
      return;
    }

    var action = form.getAttribute('action') || '';

    if (
      action.indexOf('/cart/add') !== -1 ||
      form.querySelector('[name="add"]') ||
      form.querySelector('[name="id"]')
    ) {
      setTimeout(updateMobileCartCount, 600);
    }

  }, true);


  /*
   * Some Shopify themes/apps dispatch cart-related events.
   * Listen for the common ones as well.
   */
  [
    'cart:updated',
    'cart:refresh',
    'ajaxProduct:added',
    'product:added'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      setTimeout(updateMobileCartCount, 100);
    });
  });


  /*
   * Initial count when the page loads.
   */
  document.addEventListener('DOMContentLoaded', function () {
    updateMobileCartCount();
  });

})();
